import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bot-chat',
  templateUrl: './bot-chat.component.html',
  styleUrls: ['./bot-chat.component.scss']
})
export class BotChatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
